import { orchestrator } from 'satcheljs';
import { lazyRemoveConnectedAccount } from 'owa-link-account';
import { trace } from 'owa-trace';
import { removeOWAConnectedAccount } from 'owa-accounts-store';
import {
    connectedAccountDisconnected,
    disconnectOWAConnectedAccountFailed,
    disconnectOWAAccount,
} from '../actions/publicActions';

orchestrator(disconnectOWAAccount, async ({ account }) => {
    if (account.accountProviderType == 'Outlook' || account.accountProviderType == 'Google') {
        const response = await lazyRemoveConnectedAccount.importAndExecute(account.accountId);

        if (response.status == 204) {
            // once disconnected, remove it from local client store
            removeOWAConnectedAccount(account.primarySmtpAddress);

            // Announce account disconnected so that we can deprovision truetime for the connected account
            connectedAccountDisconnected(account.primarySmtpAddress);
        } else {
            trace.warn(`Failed to remove account ${account.primarySmtpAddress}`);
            disconnectOWAConnectedAccountFailed(account.primarySmtpAddress);
        }
    } else {
        throw new Error(
            `${account.accountProviderType} provider is not yet supported for OWA Calendar`
        );
    }
});
